// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...

});

let fadeOptions = {
	"duration":   300
};

export function willkommenMouseIn(event) {
	// Add your code for this event here:
	
	let willkommenSource = "https://static.wixstatic.com/media/b6e20a_2d1606429ce243268e6f3a420574e8ad~mv2.png/v1/fill/w_358,h_86,al_c,q_85,usm_0.66_1.00_0.01/menu-items_0006_willkommen.webp"
	console.log("willkommen mouse in");
	//$w('#willkommenNavItem')
	// .style.filter = "brightness(100)"
	// show (hidden) second image which acts as shadow on hover
	// $w('#willkommenImageShadow').show("fade", fadeOptions);
	if ($w('#willkommenImageShadow').isVisible === false) {
	$w('#willkommenImageShadow').show("fade", fadeOptions);	
	}
}

export function willkommenShadowMouseOut(event) {
	// Add your code for this event here: 
	console.log("willkommen Shadow mouse out");
	if ($w('#willkommenImageShadow').isVisible === true) {
	$w('#willkommenImageShadow').hide("fade", fadeOptions);	
	}
}

export function willkommenMouseOut(event) {
	// Add your code for this event here: 
	console.log("willkommen mouse out");
	if ($w('#willkommenImageShadow').isVisible === true) {
	$w('#willkommenImageShadow').hide("fade", fadeOptions);	
	}
}